/**
 * Utility functions for price calculations in work ticket creation.
 */

/**
 * Calculate the charge price for a material based on processing code, source type, and available price data.
 *
 * Business Rules:
 * 1. RETURN processing codes (ZZHR, ZHAR) always have zero charge
 * 2. For CSP sources: use provided chargePrice, fallback to unitPriceMap, then 0
 * 3. For non-CSP sources: use provided chargePrice, fallback to 0
 *
 * @param {string|number} techRefId - Technical reference ID for the material
 * @param {number} chargePrice - The charge price from material data (can be 0, null, or undefined)
 * @param {string} processingCode - Processing code (ZZHR, ZHAR, ZHWS, ZHWA, ZZHS, ZZAE)
 * @param {Map} unitPriceMap - Map of TechRefId to UnitPrice from product catalog
 * @param {boolean} isSourceCSP - Whether the source is CSP
 * @returns {number} The calculated charge price
 *
 * @example
 * const price = getChargePrice(
 *   material.techRefId,
 *   material.chargeAmt,
 *   'ZHWS',
 *   unitPriceMap,
 *   true
 * );
 */
export const getChargePrice = (techRefId, chargePrice, processingCode, unitPriceMap, isSourceCSP) => {
  if (isSourceCSP) {
    // No charge for RETURN/EXCHANGE processing codes (ZZHR, ZHAR, ZZHS, ZZAE)
    const processingCodes = ["ZZHR", "ZHAR", "ZZHS", "ZZAE"];
    if (processingCodes.includes(processingCode)) {
      return 0;
    }
    return chargePrice || unitPriceMap.get(techRefId) || 0;
  } else {
    return chargePrice || 0;
  }
};
